// 引入 moment.js
import moment from 'moment';

export const deepCopy = (obj: any): any  => {
    // 判断是否为基本类型，如果是则直接返回
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // 判断是否为数组
    if (Array.isArray(obj)) {
        let copy = [];
        for (let i = 0; i < obj.length; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }

    // 判断是否为对象
    if (obj instanceof Object) {
        let copy: any = {};
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                copy[key] = deepCopy(obj[key]);
            }
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}



// 定义一个函数来格式化时间段
export const formatTimeRange = (startTimeStr: any, endTimeStr: any) => {
    // 将字符串转换为 moment 对象
    const startTime = moment(startTimeStr);
    const endTime = moment(endTimeStr);

    // 计算时间差
    const duration = moment.duration(endTime.diff(startTime));

    // 获取天数、小时和分钟
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();


    return `${startTime.format('YYYY-MM-DD HH:mm')+' ~ '+endTime.format('YYYY-MM-DD HH:mm')}  ${days}天${hours}小时${minutes}分钟`;
}


export const validateTwoDecimalPlaces = (_: any, value: string) => {
    if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
        return Promise.reject(new Error('至多保留两位小数'));
    }
    return Promise.resolve();
};

export const changeEnumToText = (obj: any) => {
    const { nameSpace, value, enums  } = obj
    const list = enums?.[nameSpace]
    const item = list?.find?.((item: any) => item.key === value)
    return item?.value || ''
}

export const getVideoFrameImage = (url: any, currentTime = 3, width = 100, height = 100) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.setAttribute('crossOrigin', 'anonymous')
        video.setAttribute('preload', 'metadata')
        video.setAttribute('src', url)
        // 视频开始可能是黑屏状态
        video.currentTime = currentTime
        video.addEventListener('loadeddata', function () {
        const canvas = document.createElement('canvas')
        const { videoWidth, videoHeight } = video
        const newHeight = height || videoHeight * (width / videoWidth)
        canvas.width = width
        canvas.height = newHeight
        canvas.getContext('2d')?.drawImage(video, 0, 0, 200, height)
        resolve(canvas.toDataURL('image/jpeg'))
        })
    })
}

export const isPhoneFn = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini｜Mobi｜Windows Phone/i.test(navigator.userAgent)
}
